import React, { useState } from "react"
import { Box, IconButton, Typography, useMediaQuery } from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import dayjs, { Dayjs } from "dayjs"

interface DateCalendar {
    startDate?: Dayjs
    onDateChange?: (date: Dayjs) => void
}

const DateCalendar: React.FC<DateCalendar> = ({ startDate = dayjs(), onDateChange }) => {
    const [selectedDate, setSelectedDate] = useState<Dayjs>(startDate)
    const [dateOffsetIndex, setDateOffsetIndex] = useState(0)

    // Media query to check screen width
    const isWideScreen = useMediaQuery("(min-width:500px)")

    // Generate dates for the calendar view for the current week
    const generateDates = (startIndex: number): { label: string; date: Dayjs }[] => {
        return Array.from({ length: 3 }, (_, i) => {
            const date = startDate.add(startIndex + i, "day")
            return {
                label: date.format("D-MM-YY"),
                date,
            }
        })
    }

    const maxDate = dayjs().add(7, "day")
    const minDate = dayjs().subtract(1, "day")
    const dates = generateDates(dateOffsetIndex)

    // Handle date change on click box date
    const handleDateChange = (index: number) => {
        const newDate = dates[index].date
        if (newDate.isBefore(minDate) || newDate.isAfter(maxDate)) return
        setSelectedDate(newDate)
        onDateChange?.(newDate)
    }

    // Handle next button
    const handleNext = () => {
        if (dateOffsetIndex + 1 >= 7) return
        setDateOffsetIndex((prev) => prev + 1)
    }

    // Handle prev button
    const handlePrev = () => {
        if (dateOffsetIndex - 1 < 0) return
        setDateOffsetIndex((prev) => prev - 1)
    }

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" width={"100%"} pt={1} pb={1}>
            <IconButton onClick={handlePrev} disabled={dateOffsetIndex === 0}>
                <ChevronLeftIcon />
            </IconButton>
            <Box display="flex" justifyContent="space-between" alignItems="center" height={"100%"} width={"100%"}>
                {dates.map((day, index) => (
                    <Box
                        key={day.date.toString()}
                        width={"30%"}
                        textAlign="center"
                        paddingX={1}
                        paddingY={1}
                        onClick={() => handleDateChange(index)}
                        sx={{
                            backgroundColor: selectedDate.isSame(day.date, "day") ? "primary.light" : "transparent",
                            borderRadius: 1,
                            border: 1,
                            borderColor: "primary.light",
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "primary.light",
                            },
                        }}
                    >
                        <Typography variant="body2" fontWeight="bold" color="text.primary">
                            {isWideScreen ? day.date.format("dddd") : day.date.format("ddd")}
                        </Typography>
                        <Typography variant="body2" color="text.primary">
                            {day.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
            <IconButton onClick={handleNext} disabled={dateOffsetIndex + 3 >= 7}>
                <ChevronRightIcon />
            </IconButton>
        </Box>
    )
}
export default DateCalendar
